import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

function CTFMemberCard({ name, image, institution }) {
  const data = useStaticQuery(graphql`
    {
      allFile(filter: { sourceInstanceName: { eq: "images" }, relativeDirectory: { in: ["ctf-members"] } }) {
        edges {
          node {
            relativePath
            childImageSharp {
              gatsbyImageData(width: 140, placeholder: BLURRED, formats: [AUTO, WEBP])
            }
          }
        }
      }
    }
  `);

  const { edges } = data.allFile;
  const imageNode = edges.find((edge) => edge.node.relativePath === `ctf-members/${image}`);

  if (!imageNode) {
    console.error(`Image not found: ${image}`);
    return null;
  }

  const gqlImage = getImage(imageNode.node.childImageSharp.gatsbyImageData);

  return (
    <div className="">
      <GatsbyImage
        image={gqlImage}
        alt={name}
        className="uk-object-contain match"
        style={{ height: "140px", width: "140px" }}
      />
      <ul className="uk-list uk-list-collapse uk-margin-small uk-margin-remove-top">
        <h6 className="uk-margin-remove">{name}</h6>
        <p className="uk-text-meta">{institution}</p>
      </ul>
    </div>
  );
}

const CTFMembers = [
  {
    name: "Allan Levey, MD, PhD",
    image: "01_Levey.jpg",
    institution: "Emory ADRC",
  },
  {
    name: "Rhoda Au, PhD",
    image: "02_Au.jpg",
    institution: "Boston U ADRC",
  },
  {
    name: "Lisa Barnes, PhD",
    image: "03_Barnes.jpg",
    institution: "Rush U ADRC",
  },
  {
    name: "Brad Boeve, MD",
    image: "04_Boeve.jpg",
    institution: "Mayo Clinic ADRC",
  },
  {
    name: "Jeffrey Burns, MD, MS",
    image: "05_Burns.jpg",
    institution: "U of Kansas ADRC",
  },
  {
    name: "Suzanne Schindler, MD, PhD",
    image: "06_Schindler.jpg",
    institution: "WashU Knight ADRC",
  },
  {
    name: "Cindy Carlsson, MD, MS",
    image: "07_Carlsson.jpg",
    institution: "UW Madison ADRC",
  },
  {
    name: "Greg Jicha, MD, PhD",
    image: "08_Jicha.jpg",
    institution: "U of Kentucky ADRC",
  },
  {
    name: "Andy Saykin, PsyD",
    image: "09_Saykin.jpg",
    institution: "Indiana U ADRC",
  },
  {
    name: "Mary Sano, PhD",
    image: "10_Sano.jpg",
    institution: "Mount Sinai ADRC",
  },
  {
    name: "Sandra Weintraub, PhD",
    image: "11_Weintraub.jpg",
    institution: "Northwestern ADRC",
  },
  {
    name: "Suzanne Craft, PhD",
    image: "12_Craft.jpg",
    institution: "Wake Forest ADRC",
  },
  {
    name: "Megan Zuelsdorff, PhD",
    image: "13_Zuelsdorff.jpg",
    institution: "UW Madison ADRC",
  },
  {
    name: "Howie Rosen, MD",
    image: "14_Rosen.jpg",
    institution: "UCSF ADRC",
  },
  {
    name: "Kostas Lyketsos, MD",
    image: "15_Lyketsos.jpg",
    institution: "John Hopkins ADRC",
  },
  {
    name: "Teresa Gomez-Isla, MD, PhD",
    image: "16_Gomez-Isla.jpg",
    institution: "Massachusetts ADRC",
  },
  {
    name: "Aimee Pierce, MD",
    image: "17_Pierce.jpg",
    institution: "OHSU ADRC",
  },
  {
    name: "Liana Apostolova, MD, MS",
    image: "18_Apostolova.jpg",
    institution: "Indiana ADRC",
  },
];

export default function CTFRoster() {
  return (
    <div className="uk-margin-large-top">
      <h4>Clinical Task Force Members</h4>
      <div className="uk-grid uk-child-width-1-3 uk-child-width-1-4@s uk-child-width-1-5@m uk-child-width-1-5@l uk-grid-match ">
        {CTFMembers.map((member, index) => (
          <CTFMemberCard key={index} name={member.name} image={member.image} institution={member.institution} />
        ))}
      </div>
    </div>
  );
}
